/* eslint-disable */
import {
  IApplicationDetails,
  ICustomerOnboarding,
} from "../../../modules/ninVerification/types";
import { IWorkflow } from "../../../modules/settings/types";

export const onboardingPersonsConstants = {
  ApplicationsFetchAll: "ApplicationsFetchAll",
  ApplicationsFetchLoading: "ApplicationsFetchLoading",
  APPLICATION_DETAILS: "APPLICATION_DETAILS",
  SET_SORT_PARAMS: "SET_SORT_PARAMS",
  FILTER_CO_PERSON_DATA: "FILTER_CO_PERSON_DATA",
  FILTER_DATA: "FILTER_DATA",
  FILTER_RESET: "FILTER_RESET"
};

export interface IPersonOnboardingState {
  loading: boolean;
  data: IWorkflow[];
  filter: {
    data: IWorkflow[];
    filteredBy: string;
    isOpen: false,
    CustomerName: string,
    phoneNumber: string,
    ReferenceId: string,
    channel: string
    from: string
    to: string
    status: string
  };
  sorting: {
    order: string;
    column: string;
  };
  requestDetails?: IApplicationDetails;
}

const initialState: IPersonOnboardingState = {
  loading: false,
  data: [],
  filter: {
    filteredBy: "",
    data: [],
    isOpen: false,
    CustomerName: '',
    phoneNumber: '',
    ReferenceId: '',
    channel: '',
    from: '',
    to: '',
    status: ''
  },
  sorting: {
    order: "asc",
    column: "",
  },
  requestDetails: undefined,
};

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case onboardingPersonsConstants.FILTER_CO_PERSON_DATA:
      return { ...state, ...action.payload };

    case onboardingPersonsConstants.FILTER_DATA: {
        return {...state, filter: action.payload}
    }

    case onboardingPersonsConstants.FILTER_RESET: {
      
      return {...state, filter: {
        filteredBy: "",
        data: [],
        isOpen: false,
        CustomerName: '',
        phoneNumber: '',
        ReferenceId: '',
        channel: '',
        from: '',
        to: '',
        status: ''
      },}
    }

    case onboardingPersonsConstants.SET_SORT_PARAMS:
      return { ...state, ...action.payload };

    case onboardingPersonsConstants.ApplicationsFetchAll: {
      return { ...state, loading: false, data: action.payload };
    }

    case onboardingPersonsConstants.ApplicationsFetchLoading: {
      return { ...state, loading: action.payload };
    }

    case onboardingPersonsConstants.APPLICATION_DETAILS: {
      return { ...state, data: action.payload };
    }

    default: {
      return state;
    }
  }
}
